/**
 * SoulumoWord — the canonical Soulumo wordmark used across the app.
 *
 * Mar 3 2026 · Michael picked the "Luminous" treatment from the
 * brand-preview page and asked to roll it out everywhere:
 *   Manrope · uppercase · wide letter-spacing · quiet duotone
 *   "SOUL" in warm rose-gold, "UMO" in silk cream.
 *
 * Usage:
 *   <SoulumoWord />                       // default (0.32em, medium)
 *   <SoulumoWord size="lg" />             // hero-sized
 *   <SoulumoWord size="sm" />             // small nav / footer
 *   <SoulumoWord soul="#..." umo="#..." /> // override shades
 */
import React from "react";

const DEFAULT_SOUL = "#e0a97a"; // rose-gold, from Luminous variant
const DEFAULT_UMO  = "#f5e0c5"; // silk cream

const SIZE_MAP = {
  xs: "clamp(0.7rem, 1.8vw, 0.85rem)",
  sm: "clamp(0.95rem, 2.4vw, 1.15rem)",
  md: "clamp(1.4rem, 3.6vw, 2rem)",
  lg: "clamp(1.9rem, 5vw, 3.2rem)",
  xl: "clamp(2.6rem, 7vw, 4.2rem)",
};

export default function SoulumoWord({
  size = "md",
  soul = DEFAULT_SOUL,
  umo = DEFAULT_UMO,
  tracking = "0.32em",
  weight = 300,
  className = "",
  style = {},
  "data-testid": testId = "soulumo-word",
}) {
  return (
    <span
      className={`inline-flex items-baseline ${className}`}
      style={{
        fontFamily: '"Manrope", system-ui, sans-serif',
        letterSpacing: tracking,
        fontSize: SIZE_MAP[size] || SIZE_MAP.md,
        fontWeight: weight,
        lineHeight: 1,
        textTransform: "uppercase",
        whiteSpace: "nowrap",
        ...style,
      }}
      data-testid={testId}
    >
      <span style={{ color: soul }}>Soul</span>
      <span style={{ color: umo, marginLeft: "0.04em" }}>umo</span>
    </span>
  );
}
